"use strict";

var _regeneratorRuntime = require("/var/app/products-admin/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/var/app/products-admin/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/var/app/products-admin/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.initCreate = function (uxZoomPortal) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dashboard, login, _rowNumber) {
      var dashboardList, rowNumber;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof _rowNumber !== 'number')) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return uxZoomPortal.Dashboard.findAll({
                where: {
                  login: login
                },
                attributes: ['rowNumber']
              });

            case 3:
              dashboardList = _context.sent;
              _rowNumber = Math.max.apply(Math, _toConsumableArray(dashboardList.length > 0 ? dashboardList.map(function (x) {
                return x.rowNumber;
              }) : [0]));

            case 5:
              rowNumber = _rowNumber + (typeof dashboard.rowNumber === 'number' ? dashboard.rowNumber : 1);
              _context.next = 8;
              return uxZoomPortal.Dashboard.create({
                login: login,
                tabType: dashboard.tabType,
                queryId: dashboard.queryId,
                paramsId: dashboard.paramsId,
                rowNumber: rowNumber,
                rowColumns: typeof dashboard.rowColumns === 'number' ? dashboard.rowColumns : 1,
                colNumber: typeof dashboard.colNumber === 'number' ? dashboard.colNumber : 1,
                step: dashboard.step,
                fromDate: dashboard.fromDate,
                toDate: dashboard.toDate,
                query: dashboard.query,
                date: new Date(),
                data: dashboard.data,
                urls: dashboard.urls,
                type: dashboard.type
              });

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};